import IAddinCommand from './schema/interfaces/IAddinCommand';
import RunningInstance from './schema/RunningInstance';

export default function createRunningInstance(
    controlId: string,
    addinCommand: IAddinCommand,
    hostItemIndex: string
): RunningInstance {
    return { controlId, addinCommand, hostItemIndex };
}
